/* Petname - transforma os Option Groups do Easify na jornada "Personalize em 5 passos".
   Nao depende das classes hash (po-XXXX): usa so classes semanticas po-*-root e data-pn-*.
   Idempotente: o Easify (React) pode re-renderizar, entao tudo e reaplicado via MutationObserver. */
(function () {
  'use strict';

  var TITLES = ['Cor e modelo', 'Frente da tag', 'Icones e estilo', 'Verso e adicionais'];
  var observer = null;
  var raf = 0;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function topOptions() {
    var root = $('.po-options-root');
    if (!root) return [];
    return $$(':scope > .po-option-root', root);
  }

  function groupOf(optionRoot) {
    return optionRoot.querySelector('.po-group-root');
  }
  function labelRoot(optionRoot) {
    var g = groupOf(optionRoot);
    return g ? g.querySelector(':scope > .po-field-root > .po-label-root') : null;
  }
  function wrapper(optionRoot) {
    var g = groupOf(optionRoot);
    return g ? g.querySelector(':scope > .po-field-root > .po-group-collapseWrapper') : null;
  }
  function isOpen(optionRoot) {
    var w = wrapper(optionRoot);
    /* aberto = recebe po-group-collapseWrapperOpen (po-max-h-0 continua na lista mesmo aberto) */
    return !!w && w.classList.contains('po-group-collapseWrapperOpen');
  }
  function toggle(optionRoot) {
    var t = optionRoot.querySelector('.po-group-toggle');
    if (t) t.click();
  }
  function openOnly(optionRoot) {
    topOptions().forEach(function (o) {
      if (!o.hasAttribute('data-pn-step')) return;
      var want = o === optionRoot;
      if (isOpen(o) !== want) toggle(o);
    });
  }

  function money(n) {
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }
  function parsePrice(text) {
    var m = /R\$\s*([\d.]+,\d{2})/.exec(text || '');
    return m ? parseFloat(m[1].replace('.', '').replace(',', '.')) : 0;
  }
  function basePrice() {
    try {
      var v = window.ShopifyAnalytics.meta.product.variants[0].price;
      return v / 100;
    } catch (e) { return 0; }
  }
  function productColor() {
    var h1 = $('h1');
    var t = h1 ? h1.textContent.trim() : '';
    return t.replace(/^(tag\s+\S+(\s+(mini|m|g)(?=\s))?\s+|gravatinha\s+case\s+tag\s*-\s*|(coleira|guia|peitoral)\s+)/i, '').trim();
  }

  /* ---- leitura das escolhas ---- */
  function selectedIcon() {
    var root = $('.po-imageSwatches-root');
    if (!root) return null;
    var sel = root.querySelector('[class*="selected" i], [class*="checked" i], [aria-checked="true"], [aria-selected="true"]');
    if (!sel) return null;
    var card = sel.closest('.po-imageSwatches-optionItem') || sel;
    var img = card.querySelector('img');
    var name = img ? (img.getAttribute('alt') || '') : '';
    if (!name || /^nenhum$/i.test(name)) return null;
    return { name: name, price: parsePrice(card.textContent) };
  }
  function selectedFont() {
    var r = $('.po-fontPickerSwatches-swatchInput:checked');
    return r ? r.value : '';
  }
  function frontText() {
    var i = $('.po-textField-input');
    return i ? i.value.trim() : '';
  }
  function backChoice() {
    var b = $('.po-dropdown-root .po-select-button');
    if (!b) return '';
    var ph = b.querySelector('.po-select-placeholder');
    if (ph) return '';
    return b.textContent.replace(/\s+/g, ' ').trim();
  }

  /* Valor adicional: usa o total que o proprio Easify mostra ("Valor adicional R$ 17,00"), que soma
     icone + verso + qualquer outra opcao paga. Se nao achar, soma icone + preco da opcao do verso. */
  function addonEl() {
    var root = $('.po-productPageOptions-root') || document;
    var els = $$('*', root).filter(function (el) {
      return el.children.length < 4 && /^\s*valor\s+adicional\s*R\$\s*[\d.]+,\d{2}\s*$/i.test((el.textContent || '').replace(/\s+/g, ' '));
    });
    if (!els.length) return null;
    els.sort(function (a, b) { return a.textContent.length - b.textContent.length; });
    var inner = els[0];
    /* sobe ate a caixa inteira (o ancestral mais alto que ainda so tem o texto "Valor adicional R$ x") */
    var top = inner;
    while (top.parentElement && top.parentElement !== root && /^\s*valor\s+adicional\s*R\$\s*[\d.]+,\d{2}\s*$/i.test((top.parentElement.textContent || '').replace(/\s+/g, ' '))) top = top.parentElement;
    return { inner: inner, box: top };
  }
  function addonTotal(icon) {
    var a = addonEl();
    if (a) {
      var m = /valor\s+adicional[^R]*R\$\s*([\d.]+,\d{2})/i.exec(a.inner.textContent);
      if (m) return parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
    }
    return (icon ? icon.price : 0) + parsePrice(backChoice());
  }

  /* Linhas extras com texto digitado (ex.: "2ª linha da frente: TS (+R$ 5,00)").
     Le o rotulo do campo, tira o preco "(R$ 5,00)" e usa o passo para dizer frente/verso. */
  function extraLines() {
    var out = [];
    $$('.po-textField-input').forEach(function (inp, idx) {
      if (idx === 0) return; /* o 1o campo e o texto da frente */
      var val = (inp.value || '').trim();
      if (!val) return;
      var box = inp, lab = null;
      for (var i = 0; i < 6 && box && !lab; i++) {
        box = box.parentElement;
        if (box) lab = box.querySelector('.po-label-root, label');
      }
      var raw = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
      var price = parsePrice(raw);
      var name = raw.replace(/\(?\s*R\$\s*[\d.]+,\d{2}\s*\)?/, '').replace(/[*?]/g, '').trim().toLowerCase();
      if (!name) name = 'linha extra';
      name = name.charAt(0).toUpperCase() + name.slice(1);
      var opt = inp.closest('[data-pn-step]');
      var step = opt ? parseInt(opt.getAttribute('data-pn-step'), 10) : 0;
      if (step === 2) name += ' da frente';
      else if (step === 4) name += ' do verso';
      out.push(name + ': ' + val + (price ? ' (+' + money(price) + ')' : ''));
    });
    return out;
  }

  function subtitles() {
    var icon = selectedIcon();
    var font = selectedFont();
    var style = font ? font : '';
    if (icon) style = (style ? style + ' + ' : '') + icon.name;
    return [productColor(), frontText().toUpperCase(), style, backChoice()];
  }

  /* ---- montagem ---- */
  function decorate() {
    var opts = topOptions();
    if (!opts.length) return false;
    var n = 0;
    opts.forEach(function (o) {
      if (groupOf(o)) {
        n += 1;
        o.setAttribute('data-pn-step', String(n));
        var lr = labelRoot(o);
        if (lr) lr.setAttribute('data-pn-num', String(n).padStart(2, '0'));
      } else {
        /* Esconde so divisores e opcoes realmente vazias. Reavalia a cada passada:
           um campo (ex.: Paragrafo/Mensagem) que renderiza depois deixa de ficar oculto. */
        var vazio = !o.textContent.trim() && !o.querySelector('img, svg, input, textarea, select, button, a, video, iframe');
        if (o.querySelector('.po-divider-root') || vazio) o.setAttribute('data-pn-hide', '');
        else o.removeAttribute('data-pn-hide');
      }
    });
    return n > 0;
  }

  function updateSubtitles() {
    var subs = subtitles();
    topOptions().forEach(function (o) {
      var s = parseInt(o.getAttribute('data-pn-step') || '0', 10);
      var lr = labelRoot(o);
      if (s && lr) lr.setAttribute('data-pn-sub', subs[s - 1] || '');
    });
  }

  function ensureContinue() {
    var all = topOptions().filter(function (o) { return o.hasAttribute('data-pn-step'); });
    all.forEach(function (o, idx) {
      var w = wrapper(o);
      if (!w || w.querySelector(':scope > .pn-continue')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pn-continue';
      b.textContent = idx === all.length - 1 ? 'Ver resumo' : 'Continuar';
      b.addEventListener('click', function () {
        if (idx === 1 && !frontText()) {
          b.classList.remove('pn-shake'); void b.offsetWidth; b.classList.add('pn-shake');
          var i = $('.po-textField-input'); if (i) i.focus();
          return;
        }
        var next = all[idx + 1];
        if (next) {
          openOnly(next);
          next.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          openOnly(null);
          var s = $('.pn-summary');
          if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
      w.appendChild(b);
    });
  }

  function host() {
    var el = $('.po-productPageOptions-root');
    return el ? el.closest('.shopify-app-block') || el.parentElement : null;
  }

  function ensureIntro() {
    var h = host();
    if (!h || $('.pn-intro')) return;
    var d = document.createElement('div');
    d.className = 'pn-intro';
    d.innerHTML =
      '<span class="pn-intro__tag">Produto personalizado Petname</span>' +
      '<h2 class="pn-intro__title">Personalize em 5 passos!</h2>' +
      '<p class="pn-intro__text">Montamos uma jornada mais leve para voce escolher cor, frente, estilo, verso e fechar a compra com clareza.</p>';
    h.parentNode.insertBefore(d, h);
  }

  function ensureSummary() {
    var h = host();
    if (!h) return;
    var s = $('.pn-summary');
    if (!s) {
      s = document.createElement('div');
      s.className = 'pn-summary';
      s.innerHTML =
        '<div class="pn-summary__head"><span class="pn-summary__num"></span>' +
        '<span class="pn-summary__title">Resumo final</span>' +
        '<span class="pn-summary__total-head"></span></div>' +
        '<div class="pn-summary__body"></div>';
      h.parentNode.insertBefore(s, h.nextSibling);
    }
    var nSteps = topOptions().filter(function (o) { return o.hasAttribute('data-pn-step'); }).length;
    var numEl = s.querySelector('.pn-summary__num');
    if (numEl) numEl.textContent = String(nSteps + 1).padStart(2, '0');
    var introT = $('.pn-intro__title');
    if (introT) introT.textContent = 'Personalize em ' + (nSteps + 1) + ' passos!';
    var icon = selectedIcon();
    var add = addonTotal(icon);
    var total = basePrice() + add;
    var ae = addonEl();
    if (ae) ae.box.setAttribute('data-pn-addon-orig', '');
    var back = backChoice();
    var lines = [];
    var color = productColor(); if (color) lines.push('Cor: ' + color);
    var f = frontText(); if (f) lines.push('Frente: ' + f.toUpperCase());
    var extras = extraLines();
    var font = selectedFont(); if (font) lines.push('Fonte: ' + font);
    if (icon) lines.push('Icone: ' + icon.name + (icon.price ? ' (+' + money(icon.price) + ')' : ''));
    if (back) lines.push('Verso: ' + back);
    extras.forEach(function (l) { lines.push(l); });
    var esc = function (t) { return t.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); };
    s.querySelector('.pn-summary__total-head').textContent = total ? money(total) : '';
    s.querySelector('.pn-summary__body').innerHTML =
      '<strong>Suas escolhas:</strong>' +
      (lines.length ? '<ul>' + lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>' : '<p>Nenhuma escolha feita ainda.</p>') +
      (total ? '<div class="pn-summary__total">Total: ' + money(total) + '</div>' : '');
  }

  function apply() {
    raf = 0;
    if (observer) observer.disconnect();
    try {
      if (decorate()) {
        ensureIntro();
        ensureContinue();
        updateSubtitles();
        ensureSummary();
      }
    } finally {
      start();
    }
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(apply); }

  var firstOpened = false;
  function start() {
    var target = $('.shopify-app-block') && $('.po-productPageOptions-root') ? $('.po-productPageOptions-root').closest('.shopify-app-block') : document.body;
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(target, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'value', 'aria-checked', 'aria-selected'] });
  }

  function scheduleLater() { schedule(); setTimeout(schedule, 150); setTimeout(schedule, 500); }
  document.addEventListener('input', scheduleLater, true);
  document.addEventListener('change', scheduleLater, true);
  document.addEventListener('click', scheduleLater, true);

  /* Acordeao: so uma etapa aberta por vez ao clicar no cabecalho */
  document.addEventListener('click', function (e) {
    var lr = e.target.closest && e.target.closest('.po-label-root[data-pn-num]');
    var tg = e.target.closest && e.target.closest('.po-group-toggle');
    var o = (lr || tg) && (lr || tg).closest('.po-option-root[data-pn-step]');
    if (!o) return;
    setTimeout(function () {
      if (isOpen(o)) topOptions().forEach(function (x) { if (x !== o && x.hasAttribute('data-pn-step') && isOpen(x)) toggle(x); });
      schedule();
    }, 60);
  }, true);

  function boot() {
    if ($('.po-productPageOptions-root')) {
      apply();
      if (!firstOpened) {
        firstOpened = true;
        var first = topOptions().filter(function (o) { return o.hasAttribute('data-pn-step'); })[0];
        if (first && !isOpen(first)) toggle(first);
      }
    } else {
      setTimeout(boot, 400);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();